import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const TopSpacer = styled.div `
    height: 24px;
`;
export const Explanation = styled.div `
    color: ${colors.black_light};
    line-height: normal;
`;
export const TextContainer = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const ButtonContainer = styled(FlexColumnDiv) `
    gap: 6px;
`;
